module.exports = __webpack_public_path__ + "static/img/bg.e06a616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/hotDog/bg.jpg
// module id = +WEI
// module chunks = 3